import * as React from 'react';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Select from '@rio-cloud/rio-uikit/Select';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { getLanguageDropDownItems } from './languageHelpers';
import { patchLocaleThunk } from '../../thunks';
import { isMaintenanceMode, selectPending } from '../../appSlice';
import { renderSpinner } from '../../common';
import { useAppDispatch, useAppSelector } from '../../../../configuration/setup/hooks';
import { getLocale } from '../../../../configuration/lang/langSlice';
import { SelectOption } from '@rio-cloud/rio-uikit';
import { getTenant } from '../../../../configuration/tokenHandling/tokenHandlingSlice';

export const Language: React.FC = () => {
    const displayLocale = useAppSelector(getLocale) ?? 'en-GB';
    const isPending = useAppSelector(selectPending);
    const tenant = useAppSelector(getTenant);
    const isInMaintenanceMode = useAppSelector(isMaintenanceMode);

    const [updatedLocale, setLocale] = useState(displayLocale);

    const dispatch = useAppDispatch();
    const intl = useIntl();

    const isDisabled = () => {
        if (updatedLocale === displayLocale || isInMaintenanceMode) {
            return 'disabled';
        }
        return '';
    };

    const onChange = (e: SelectOption | undefined) => setLocale(e?.id ?? 'en-GB');

    const renderConfirmText = () => {
        const textNode = intl.formatMessage({ id: 'intl-msg:settingsDialog.tab.language.button.save.label' });
        return isPending ? <Spinner text={textNode} /> : textNode;
    };

    const renderSaveButton = () => (
        <div className={'btn-toolbar pull-right margin-top-20 margin-bottom-20'}>
            <div
                className={`btn btn-primary ${isDisabled()}`}
                onClick={() => dispatch(patchLocaleThunk(updatedLocale))}
                data-cy={'locale-data-save-btn'}
            >
                {renderConfirmText()}
            </div>
        </div>
    );

    const renderContent = () => (
        <div data-cy={'language-content'}>
            <div className="form-group">
                <label className={'control-label'}>
                    <FormattedMessage id={'intl-msg:settingsDialog.tab.language.label.language'} />
                </label>
                <Select
                    className={'inputLanguage'}
                    placeholder={'intl-msg:settingsDialog.tab.language.select.placeholder'}
                    onChange={onChange}
                    options={getLanguageDropDownItems(updatedLocale, tenant, intl)}
                    disabled={isInMaintenanceMode}
                />
            </div>
            {renderSaveButton()}
        </div>
    );

    return <>{isPending ? renderSpinner() : renderContent()}</>;
};
